import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { Button } from "reactstrap";
import { IScreenStatus, showScreenAsSelected } from "../../app/models/screens";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  screen: IScreenStatus;
}

const ScreenSelectionCheckbox: React.FC<IParams> = ({ screen }) => {
  const rootStore = useContext(RootStoreContext);
  const { toggleScreenSelection } = rootStore.screensStore;

  const getScreenSelectionClassName = () => {
    if (showScreenAsSelected(screen)) return "fa-check-circle text-success";
    else return "fa-circle text-default";
  };

  const handleClick = () => {
    toggleScreenSelection(screen.id);
  }

  return (
    <Button
      id={`lnkEdit_${screen.id}`}
      color="none"
      onClick={handleClick}
      className="screenListButton"
    >
      <i
        className={classNames(
          "far",
          getScreenSelectionClassName(),
          "fa-2x iconBoxList"
        )}
      ></i>
    </Button>
  );
};

export default observer(ScreenSelectionCheckbox);
